import React from 'react';
import './ClientReviews.css';
import logo from '../assets/jnit logo.png';

const ClientReviews = () => {
  const reviews = [
    {
      quote: "Partnering with ",
      company: "JN IT DIGITAL SOLUTIONS",
      restQuote: " transformed our business. Their strategic insights sharpened our direction, and their team's execution delivered impactful results that truly connected with our audience.",
      name: "Dr.Suvvari Mahesh Chandra",
      affiliation: "Mayuran Multispeciality Clinic"
    },
    {
      quote: "Our collaboration with ",
      company: "JN IT DIGITAL SOLUTIONS",
      restQuote: " has had a substantial impact on our digital growth. Their expertise in content strategy, coupled with their unwavering reliability, has elevated our online presence and performance.",
      name: "Dr.Gadam",
      affiliation: "PHOENIX DENTAL CARE"
    }
  ];

  return (
    <section className="client-reviews-section">
      <div className="reviews-logo">
        <img src={logo} alt="JN IT Digital Solutions Logo" />
      </div>
      <div className="reviews-header">
        <h5>TESTIMONIALS</h5>
        <h2>What Our Clients Say</h2>
      </div>
      <div className="reviews-cards">
        {reviews.map((review, index) => (
          <div className="review-card" key={index}>
            <p className="quote">
              “{review.quote}
              <strong>{review.company}</strong>
              {review.restQuote}”
            </p>
            <p className="client-name">{review.name}</p>
            <p className="client-affiliation">{review.affiliation}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ClientReviews;
